import React, { FC, memo, useEffect, useState } from 'react'
import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import ChatIcon from '@ucheba/ui/icons/icon__chat.svg'
import SC from '../base/RequestWidget.styles'
import { IRequestWidgetProps } from '../types'

const { Block: BlockSC, ButtonWrapper } = SC

const Block = styled<StyledProps<any>>(BlockSC)`
  bottom: ${(props) => props.bottom};
  right: ${(props) => props.right};
  z-index: 999;
  transition: 0.3s;
`

const ButtonSC = styled.button`
  border-radius: 50%;
  padding: 12px;
  width: 48px;
  height: 48px;
  cursor: pointer;
  background-color: white;
`

/** Виджет телефона */
const RequestWidget: FC<IRequestWidgetProps> = (props) => {
  const { onClick, bottom } = props
  const [state, setState] = useState({
    bottom: bottom || sv.spacing.xlarge,
    right: sv.spacing.xlarge,
  })

  useEffect(() => {
    const bottomBanner = document.querySelector('.bottom-banner')

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const item = mutation.target as HTMLElement
        const classes = item.className

        if (!classes.includes('bottom-banner')) {
          setState({
            bottom: sv.spacing.xlarge,
            right: sv.spacing.xlarge,
          })
        }
      })
    })

    if (bottomBanner) {
      observer.observe(bottomBanner, {
        attributes: true,
      })

      setState({
        bottom: sv.spacing.uxxlarge,
        right: sv.spacing.xlarge,
      })
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <Block bottom={state.bottom} right={state.right}>
      <ButtonWrapper>
        <ButtonSC onClick={onClick}>
          <ChatIcon width='24px' height='24px' color='black' />
        </ButtonSC>
      </ButtonWrapper>
    </Block>
  )
}

export { RequestWidget }
export default memo(RequestWidget)
